import { v4 as uuidv4 } from 'uuid';

export const TINY_MCE_CONFIG = onInsertContent => ({
    height: 640,
    width: '100%',
    menubar: false,
    plugins: ['link'],
    paste_as_text: true,
    block_formats: 'Paragraph=p; Header 1=h1; Header 2=h2; Header 3=h3',
    toolbar:
        'undo redo | blocks | bold italic underline forecolor link | alignleft aligncenter alignright | placeholders artist event text checkbox',
    content_style:
        'body { font-family:Helvetica,Arial,sans-serif; font-size:14px } ev, art, stg, prfd, sgn, sgne, sgna, prfh {background-color: #c7d9ef; border-radius: 20px;} .is-with-comment {background-color: rgba(189, 81, 59, 0.5); border-radius: 10px; padding: 10px; cursor: hover;}',
    extended_valid_elements: 'ev[*],art[*],stg[*],prfd[*],prfh[*],sgn[*],sgna[*],sgne[*]',
    custom_elements: '~ev,~art,~stg,~prfd,~prfh,~sgn,~sgna,~sgne',
    valid_children: '+p[ev,art,stg,prfd,prfh,sgn,sgna,sgne]',
    text_patterns: [
        { start: '#', format: 'h1' },
        { start: '##', format: 'h2' },
        { start: '###', format: 'h3' }
        // { start: '*', end: '*', format: 'italic' },
        // { start: '**', end: '**', format: 'bold' },
        // { start: '####', format: 'h4' },
        // { start: '#####', format: 'h5' },
        // { start: '######', format: 'h6' }
        // { start: '1. ', cmd: 'InsertOrderedList' },
        // { start: '* ', cmd: 'InsertUnorderedList' },
        // { start: '- ', cmd: 'InsertUnorderedList' }
    ],
    setup: editor => {
        editor.ui.registry.addMenuButton('placeholders', {
            text: 'Placeholders',
            fetch: function (callback) {
                var items = [
                    {
                        type: 'menuitem',
                        text: 'Artist name',
                        onAction: () => {
                            editor.insertContent('<art contenteditable=false>ARTIST NAME</art>', {
                                format: 'raw'
                            });
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'Event name',
                        onAction: () => {
                            editor.insertContent('<ev contenteditable=false>EVENT NAME</ev>');
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'Performance Stage',
                        onAction: () => {
                            editor.insertContent('<stg contenteditable=false>PERFORMANCE STAGE</stg>');
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'Performance Date',
                        onAction: () => {
                            editor.insertContent('<prfd contenteditable=false>PERFORMANCE DATE</prfd>');
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'Performance Hours',
                        onAction: () => {
                            editor.insertContent('<prfh contenteditable=false>PERFORMANCE HOURS</prfh>');
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'Both Artist & Event Organizer',
                        onAction: () => {
                            editor.insertContent('<sgn contenteditable=false>Signatures</sgn>');
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'Signature Artist',
                        onAction: () => {
                            editor.insertContent('<sgna contenteditable=false>Signature Artist</sgna>');
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'Signature Event Organizer',
                        onAction: () => {
                            editor.insertContent('<sgne contenteditable=false>Signature Event Organizer</sgne>');
                        }
                    }
                ];
                callback(items);
            }
        });
        editor.ui.registry.addButton('checkbox', {
            text: 'CHECKBOX',
            tooltip: 'Insert checkbox',
            onAction: () => {
                const uuid = uuidv4();
                editor.insertContent(`<input id="${uuid}" type="checkbox" />`);
            }
        });
        editor.ui.registry.addMenuButton('text', {
            text: 'INPUT FIELDS',
            fetch: function (callback) {
                var items = [
                    {
                        type: 'menuitem',
                        text: 'OPTIONAL',
                        onAction: () => {
                            const uuid = uuidv4();
                            editor.insertContent(`<input id="${uuid}" type="text" />`);
                        }
                    },
                    {
                        type: 'menuitem',
                        text: 'REQUIRED',
                        onAction: () => {
                            const uuid = uuidv4();
                            editor.insertContent(`<input id="CLR_REQ_${uuid}" type="text" />`);
                        }
                    }
                ];
                callback(items);
            }
        });
    },
    init_instance_callback: function (editor) {
        editor.on('ExecCommand', function (e) {
            if (e.command === 'mceInsertContent') {
                onInsertContent && onInsertContent();
            }
        });
    }
});
